<div class="box">
  <div class="box-row header">
    <app-header-bar [title]="'support.title'"></app-header-bar>
  </div>
  <div class="box-row content mt-2">
    <div class="row w-100">
      <p-tabs
        [value]="activeTab"
        (valueChange)="onTabChange($event)"
        class="w-100"
      >
        <p-tablist>
          <p-tab value="docs">{{ 'support.docs' | translate }}</p-tab>
          <p-tab value="ticket">{{ 'support.ticket.name' | translate }}</p-tab>
          <p-tab value="email">{{ 'support.email.name' | translate }}</p-tab>
        </p-tablist>
        <p-tabpanels>
          <p-tabpanel value="docs" class="pt-4">
            <div class="d-flex flex-row flex-wrap page-wrapper">
              <div class="card-wrapper">
                <div class="card">
                  <div class="card-body">
                    <h3 class="card-title">
                      <span>{{ 'support.doc1.title' | translate }}</span>
                    </h3>
                    <p>{{ 'support.doc1.description' | translate }}</p>
                    <a
                      [href]="environment.documentation1Url"
                      target="_blank"
                      class="btn btn-primary"
                      >{{ 'support.doc.button' | translate }}</a
                    >
                  </div>
                </div>
              </div>
              <div class="card-wrapper">
                <div class="card">
                  <div class="card-body">
                    <h3 class="card-title">
                      <span>{{ 'support.doc2.title' | translate }}</span>
                    </h3>
                    <p>{{ 'support.doc2.description' | translate }}</p>
                    <a
                      [href]="environment.documentation2Url"
                      target="_blank"
                      class="btn btn-primary"
                      >{{ 'support.doc.button' | translate }}</a
                    >
                  </div>
                </div>
              </div>
            </div>
          </p-tabpanel>
          <p-tabpanel value="ticket" />
          <p-tabpanel value="email" class="pt-2">
            <p>{{ 'support.email.text' | translate }}</p>
            <app-email-form></app-email-form>
          </p-tabpanel>
        </p-tabpanels>
      </p-tabs>
    </div>
  </div>
</div>
